import { render, staticRenderFns } from "./CourseUpload.vue?vue&type=template&id=6ba44a11&scoped=true"
import script from "./CourseUpload.vue?vue&type=script&lang=js"
export * from "./CourseUpload.vue?vue&type=script&lang=js"
import style0 from "./CourseUpload.vue?vue&type=style&index=0&id=6ba44a11&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba44a11",
  null
  
)

export default component.exports